import { toAbsoluteUrl } from '../../../../_metronic/helpers';

type VendorCampaignType = {
  mobileDevice: boolean;
};

export default function VendorCampaign(props: VendorCampaignType) {
  const { mobileDevice } = props;
  return (
    <div className="d-flex px-6 flex-column gap-2">
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className={`fw-bold ${mobileDevice ? 'fs-4' : 'fs-2'}`}>Kampanyalar</div>
        <div className="fs-8 text-danger">Bu alan nasıl görüneceğinin ön izlemesidir.</div>
      </div>

      <div className="d-flex w-100 align-items-center justify-content-center">
        <img src={toAbsoluteUrl(`/media/showcasepage-images/${mobileDevice ? 'ide-campaigns-mobile' : 'ide-campaigns'}.png`)} alt="Idefix Campaigns" />
      </div>
    </div>
  );
}
